import { render, staticRenderFns } from "./gridPageEditWrapper.vue?vue&type=template&id=f6b3068a&scoped=true&"
import script from "./gridPageEditWrapper.vue?vue&type=script&lang=js&"
export * from "./gridPageEditWrapper.vue?vue&type=script&lang=js&"
import style0 from "./gridPageEditWrapper.vue?vue&type=style&index=0&id=f6b3068a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b3068a",
  null
  
)

export default component.exports